'use strict';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = WithRouter;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _reactRouterDom = require("react-router-dom");
function WithRouter(Component) {
  const Wrapper = props => {
    const navigate = (0, _reactRouterDom.useNavigate)();
    const output = /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({}, props, {
      navigate: navigate
    }));
    return output;
  };
  return Wrapper;
}
